/* Generated by Codex */
import * as React from "react";
import { useTranslation } from "react-i18next";
import RedwoodModal from "../../common/Modal/RedwoodModal";
import { useFormDispatch, useFormState } from "../main/ActivationForm/Context/ActivationFormContext";
import "./OrderDetailsModal.css";

const formatSku = (sku: { skuNumber: string; skuName?: string }) => (
  sku.skuName ? `${sku.skuNumber}: ${sku.skuName}` : sku.skuNumber
);

const OrderDetailsModal = () => {
  const { t } = useTranslation();
  const dispatch = useFormDispatch();
  const {
    loading,
    loadingFeatureFlags,
    nonAuth,
    nonPending,
    processing,
    showThankYou,
    showBanner,
    tokenHasExpired,
    fawError,
    showODBGModal,
    showOrderDetailsModal,
    subscriptionIds,
    orderPillars,
    orderSkus,
  } = useFormState();
  const wrapper = document.getElementById("main");
  const pillarNames = Object.keys(orderPillars);
  const hasPillars = pillarNames.length > 0;
  const hasFallbackSkus = orderSkus.length > 0;
  const showModal =
    showOrderDetailsModal &&
    (hasPillars || hasFallbackSkus) &&
    !loading &&
    !loadingFeatureFlags &&
    !nonAuth &&
    !nonPending &&
    !processing &&
    !showThankYou &&
    !showBanner &&
    !tokenHasExpired &&
    !fawError &&
    !showODBGModal;

  React.useEffect(() => {
    if (!wrapper) {
      return;
    }

    if (showModal) {
      wrapper.classList.add("modal-open");
    } else {
      wrapper.classList.remove("modal-open");
    }

    return () => {
      wrapper.classList.remove("modal-open");
    };
  }, [showModal, wrapper]);

  const closeModal = () => {
    dispatch({
      type: "CLOSE_ORDER_DETAILS_MODAL",
      payload: "boolean",
      boolean: false,
    });
  };

  if (!showModal) {
    return null;
  }

  return (
    <RedwoodModal
      show={true}
      title={t("subscriptionBlock.detailsTitle", "Subscription Details")}
      fullContainer={true}
      closeBtn={true}
      onClose={closeModal}
      buttonName={t("common.close", "Close")}
      wrapperClass="order-details-modal"
    >
      <div className="order-details-content" data-testid="order-details-modal">
        {subscriptionIds && subscriptionIds.length > 0 && (
          <div className="order-details-subscriptions">
            {subscriptionIds.map((subscriptionId) => (
              <p key={subscriptionId}>
                <span className="order-details-label">{t("subscriptionBlock.subId", "Subscription ID")}: </span>
                {subscriptionId}
              </p>
            ))}
          </div>
        )}
        {hasPillars ? (
          <div className="order-details-list">
            {pillarNames.map((pillarName) => (
              <section key={pillarName} className="order-details-pillar">
                <h3>{pillarName}</h3>
                {orderPillars[pillarName].length > 0 && (
                  <ul>
                    {orderPillars[pillarName].map((sku) => (
                      <li key={`${pillarName}-${sku.skuNumber}-${sku.skuName || ""}`}>{formatSku(sku)}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
            {/* // START: Codex Edit */}
            {hasFallbackSkus && (
              <section className="order-details-pillar">
                <h3>{t("subscriptionBlock.additionalSkus", "Additional SKUs")}</h3>
                <ul className="order-details-skus">
                  {orderSkus.map((sku) => (
                    <li key={`unmapped-${sku.skuNumber}-${sku.skuName || ""}`}>{formatSku(sku)}</li>
                  ))}
                </ul>
              </section>
            )}
            {/* // END: Codex Edit */}
          </div>
        ) : (
          <div className="order-details-list">
            <ul className="order-details-skus">
              {orderSkus.map((sku) => (
                <li key={`${sku.skuNumber}-${sku.skuName || ""}`}>{formatSku(sku)}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </RedwoodModal>
  );
};

export default OrderDetailsModal;
